import React from 'react';
import EditorUnderline from '@wix/da-ds/pkg/Icons/24x24/EditorUnderline';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';

const Underline: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');

  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'underline'))
  ) {
    return null;
  }
  return (
    <EditorIconButton
      featureId="format:underline"
      icon={EditorUnderline}
      onClick={() => editor.chain().focus().toggleUnderline().run()}
      disabled={!editor.can().chain().focus().toggleUnderline().run()}
      isActive={editor.isActive('underline')}
      tooltipText={t('button.underline.tooltip')}
      aria-label={t('button.underline.tooltip')}
    />
  );
};
Underline.displayName = 'Underline';

export default Underline;
